import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { pullDAGCQualificationStatus } from "../../services/ads/ads.service";

import { Loading } from "../../components";
import Text from "../../components/Text";


const DOWNLOAD = () => {

    const location = useLocation();

    const { t } = useTranslation();

    const DAGCSessionId: String = new URLSearchParams(location.search).get("dagc_session_id") ?? "";

    const [errorMessage, setErrorMessage] = useState("");

    const [loadingMessage, setLoadingMessage] = useState("");

    function pull(
        intervalIdContainer: { intervalId: null | ReturnType<typeof setInterval> },
        countContainer: { count: number },
    ) {
        /**
         * Start with count = 0 for first execution of this function body.
         *
         * 0 second => fetch
         * 1 second => skip
         * 2 second => fetch
         * 3 second => skip
         * 4 second => fetch
         * 5 second => skip
         * 6 second => stopPulling
         * 7 second => Show sorry message
         */
        const count = countContainer.count++;

        function stopPulling() {
            if (intervalIdContainer.intervalId !== null) {
                clearInterval(intervalIdContainer.intervalId);
                intervalIdContainer.intervalId = null;
            }
        }

        if (count === 6) {
            stopPulling();
            setLoadingMessage("0");
            setTimeout(
                () => {
                    setLoadingMessage("Sorry, it is taking more than the expected time, if you are not redirected in the next 5 seconds, please try again");
                }, 1000
            );
        } else if (count < 6) {
            setLoadingMessage("" + (6 - count));

            if (count % 2 === 0) {
                pullDAGCQualificationStatus(DAGCSessionId, count === 4)
                    .then(
                        response => {
                            if (response.data) {
                                const { qualified, msg_code, redirect_url } = response.data;

                                if (!qualified) {
                                    setErrorMessage(msg_code);
                                    stopPulling();
                                } else if (response.status === 200 && redirect_url) {
                                    window.location.href = redirect_url;
                                }
                            }
                        }
                    )
                    .catch(
                        error => {
                            setErrorMessage(error.response.data.msg_code);
                            stopPulling();
                            console.error(error);
                        }
                    );
            }
        }
    }

    useEffect(
        () => {
            const countContainer: { count: number } = { count: 0 };
            const intervalIdContainer: { intervalId: null | ReturnType<typeof setInterval> } = { intervalId: null };

            intervalIdContainer.intervalId = setInterval(() => pull(intervalIdContainer, countContainer), 1000);

            return () => {
                if (intervalIdContainer.intervalId !== null) {
                    clearInterval(intervalIdContainer.intervalId);
                }
            };
        },
        []
    );

    return errorMessage
        ? (
            <div style={{ position: "fixed", width: "100%", fontSize: "2rem", top: "50%", left: 0, textAlign: "center", zIndex: 10000 }}>
                <Text>{t(errorMessage)}</Text>
            </div>
        )
        : loadingMessage
            ? (
                <>
                    <Loading />
                    <div style={{ position: "fixed", width: "100%", fontSize: "2rem", top: "55%", left: 0, textAlign: "center", zIndex: 10000 }}>
                        <Text>{t(loadingMessage)}</Text>
                    </div>
                </>
            )
            : <Loading />;
};

export default DOWNLOAD;
